import { useState } from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function FAQSection() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs = [
    { key: 'q1', question: t('pricing.faq.q1.question'), answer: t('pricing.faq.q1.answer') },
    { key: 'q2', question: t('pricing.faq.q2.question'), answer: t('pricing.faq.q2.answer') },
    { key: 'q3', question: t('pricing.faq.q3.question'), answer: t('pricing.faq.q3.answer') },
    { key: 'q5', question: t('pricing.faq.q5.question'), answer: t('pricing.faq.q5.answer') },
    { key: 'q6', question: t('pricing.faq.q6.question'), answer: t('pricing.faq.q6.answer') },
    { key: 'q7', question: t('pricing.faq.q7.question'), answer: t('pricing.faq.q7.answer') },
    { key: 'q8', question: t('pricing.faq.q8.question'), answer: t('pricing.faq.q8.answer') },
    { key: 'q9', question: t('pricing.faq.q9.question'), answer: t('pricing.faq.q9.answer') },
    { key: 'q10', question: t('pricing.faq.q10.question'), answer: t('pricing.faq.q10.answer') },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        width: '100vw',
        marginLeft: 'calc(-50vw + 50%)',
        background: '#212529',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: '2rem', md: '2.5rem' },
            fontWeight: 700,
            textAlign: 'center',
            mb: 6,
            color: '#FFFFFF',
          }}
        >
          {t('pricing.faq.title')}
        </Typography>

        <Box sx={{ '& .MuiAccordion-root': { mb: 1.5 } }}>
          {faqs.map((faq, index) => (
            <Accordion
              key={faq.key}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
              elevation={0}
              disableGutters
              sx={{
                background: 'linear-gradient(135deg, rgba(44, 48, 52, 0.9) 0%, rgba(33, 37, 41, 0.95) 100%)',
                border: '1px solid rgba(144, 202, 249, 0.1)',
                borderRadius: '12px !important',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:before': {
                  display: 'none',
                },
                '&.Mui-expanded': {
                  margin: '0 0 12px 0 !important',
                  border: '1px solid rgba(144, 202, 249, 0.3)',
                  boxShadow: '0 8px 32px rgba(144, 202, 249, 0.15)',
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{
                      color: '#90caf9',
                      transition: 'all 0.3s ease',
                    }}
                  />
                }
                sx={{
                  minHeight: 56,
                  px: 2.5,
                  '& .MuiAccordionSummary-content': {
                    my: 0,
                  },
                  '&.Mui-expanded': {
                    minHeight: 56,
                  },
                  '&:hover': {
                    background: 'rgba(144, 202, 249, 0.05)',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 600,
                    color: '#FFFFFF',
                  }}
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  px: 2.5,
                  pb: 2.5,
                  pt: 0,
                  borderTop: '1px solid rgba(144, 202, 249, 0.1)',
                }}
              >
                <Typography
                  sx={{
                    color: '#ADB5BD',
                    lineHeight: 1.7,
                    fontSize: '0.95rem',
                    pt: 1.5,
                  }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default FAQSection;
